import { Base } from './base.model';

export class AppConfig extends Base {
  public key: string;
  public value: string;
  public description: string;
}
